import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import { AuthContext } from '../../context/AuthContext';
import { ContaPagarContext } from '../../context/ContaPagarContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { TipoContaPagarContext } from '../../context/TipoContaPagarContext';
import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { ContaPagarType, CreateContaPagarType, UpdateContaPagarType, EfetuarBaixaPagarRequest } from '../../context/hooks/useContaPagar';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateContaPagarModal } from '../../components/ContaPagar/CreateContaPagarModal';
import { EditContaPagarModal } from '../../components/ContaPagar/EditContaPagarModal';
import { CreateMultiplasContasPagarModal } from '../../components/ContaPagar/CreateMultiplasContasPagarModal';
import { ExportRelatorioModal } from '../../components/ContaPagar/ExportRelatorioModal';

const ContaPaga = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listContaPagar, contaPagarPageCount, getAllContaPagarPaged, deleteContaPagar, reverterContaParaPendente, contaPagarTotalValor, exportRelatorioContaPagar } = useContext(ContaPagarContext);
    const { handleGetContaFinanceiraByEmpresaId, listContaFinanceiraByEmpresa } = useContext(ContaFinanceiraContext);
    const { handleGetCategoriaFinanceiraByEmpresaId, listCategoriaFinanceiraByEmpresa } = useContext(CategoriaFinanceiraContext);
    const { handleGetTipoContaPagarByEmpresaId, listTipoContaPagarByEmpresa } = useContext(TipoContaPagarContext);
    const { handleGetFormaPagamentoByEmpresaId, listFormaPagamentoByEmpresa } = useContext(FormaPagamentoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [editingContaPagar, setEditingContaPagar] = useState<UpdateContaPagarType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [createMultiplasModalOpen, setCreateMultiplasModalOpen] = useState(false);
    const [exportModalOpen, setExportModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        dataInicial: '',
        dataFinal: '',
        codigoTransacao: '',
        documento: '',
        historico: '',
        contaFinanceiraId: '',
        categoriaFinanceiraId: '',
        formaPagamentoId: '',
        tipoContaPagarId: ''
    });

    useEffect(() => {
        setLoading(true);

        handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);
        handleGetTipoContaPagarByEmpresaId(objUserTk.EmpresaId);

        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar contas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllContaPagarPaged(
            value,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
            filters.dataFinal,
            1,
            filters.codigoTransacao || undefined,
            filters.documento || undefined,
            filters.historico || undefined,
            filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
            filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
            filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
            filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined
        );
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllContaPagarPaged(
            1,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
            filters.dataFinal,
            1,
            filters.codigoTransacao || undefined,
            filters.documento || undefined,
            filters.historico || undefined,
            filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
            filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
            filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
            filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined
        )
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({
            dataInicial: '',
            dataFinal: '',
            codigoTransacao: '',
            documento: '',
            historico: '',
            contaFinanceiraId: '',
            categoriaFinanceiraId: '',
            formaPagamentoId: '',
            tipoContaPagarId: ''
        });
        setLoading(true);
        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditContaPagar = (contaPagar: ContaPagarType) => {
        setEditingContaPagar(contaPagar);
        setEditModalOpen(true);
    };

    const handleDeleteContaPagar = (contaPagarId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta conta?")) {
            deleteContaPagar(contaPagarId)
                .then(deletedContaPagar => {
                    if (deletedContaPagar) {
                        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1);
                    } else {
                        console.error("Erro ao excluir conta.");
                    }
                    getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1);
                })
                .catch(error => {
                    console.error("Erro ao excluir conta:", error);
                });
        }
    };

    const colorMapByDay: { [key: number]: string } = {
        1: "#FFEBEE",
        2: "#E3F2FD",
        3: "#E8F5E9",
        4: "#FFF3E0",
        5: "#F3E5F5",
        6: "#FBE9E7",
        7: "#E0F2F1",
        8: "#FFF8E1",
        9: "#EDE7F6",
        10: "#ECEFF1",
        11: "#FFCDD2",
        12: "#BBDEFB",
        13: "#C8E6C9",
        14: "#FFE0B2",
        15: "#D1C4E9",
        16: "#FFCCBC",
        17: "#B2DFDB",
        18: "#FFECB3",
        19: "#D7CCC8",
        20: "#CFD8DC",
        21: "#F48FB1",
        22: "#90CAF9",
        23: "#A5D6A7",
        24: "#FFAB91",
        25: "#CE93D8",
        26: "#FF8A65",
        27: "#80CBC4",
        28: "#FFD54F",
        29: "#BCAAA4",
        30: "#B0BEC5",
        31: "#F06292"
    };

    const getColorByDay = (date: string): string => {
        const day = new Date(date).getDate();
        return colorMapByDay[day] || "#FFFFFF";
    };

    const listCategoriaFinanceiraOptions = listCategoriaFinanceiraByEmpresa.map(categoriaFinanceira => ({
        value: categoriaFinanceira.id,
        label: categoriaFinanceira.name,
    }));

    const listContaFinanceiraOptions = listContaFinanceiraByEmpresa.map(contaFinanceira => ({
        value: contaFinanceira.id,
        label: contaFinanceira.name,
    }));

    const listFormaPagamentoOptions = listFormaPagamentoByEmpresa.map(fp => ({
        value: fp.id,
        label: fp.name
    }));

    const listTipoContaPagarOptions = listTipoContaPagarByEmpresa.map(tipo => ({
        value: tipo.id,
        label: tipo.name
    }));

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Conta Pagar"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">

                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Data Inicial</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataInicial"
                            value={filters.dataInicial}
                            onChange={handleFilterChange}
                            placeholder="Data inicial"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Data Final</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataFinal"
                            value={filters.dataFinal}
                            onChange={handleFilterChange}
                            placeholder="Data final"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Código Transação</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="codigoTransacao"
                            value={filters.codigoTransacao}
                            onChange={handleFilterChange}
                            placeholder="Código da transação"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Documento</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="documento"
                            value={filters.documento}
                            onChange={handleFilterChange}
                            placeholder="Número do documento"
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Histórico</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="historico"
                            value={filters.historico}
                            onChange={handleFilterChange}
                            placeholder="Buscar por histórico"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Conta Financeira</Label>
                        <Select
                            className="form-control-alternative"
                            options={listContaFinanceiraOptions}
                            value={listContaFinanceiraOptions.find(opt => opt.value.toString() === filters.contaFinanceiraId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, contaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma conta financeira"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Categoria Financeira</Label>
                        <Select
                            className="form-control-alternative"
                            options={listCategoriaFinanceiraOptions}
                            value={listCategoriaFinanceiraOptions.find(opt => opt.value.toString() === filters.categoriaFinanceiraId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, categoriaFinanceiraId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione uma categoria"
                        />
                    </Col>
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Forma de Pagamento</Label>
                        <Select
                            className="form-control-alternative"
                            options={listFormaPagamentoOptions}
                            value={listFormaPagamentoOptions.find(opt => opt.value.toString() === filters.formaPagamentoId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, formaPagamentoId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione a forma de pagamento"
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Tipo de Conta Pagar</Label>
                        <Select
                            className="form-control-alternative"
                            options={listTipoContaPagarOptions}
                            value={listTipoContaPagarOptions.find(opt => opt.value.toString() === filters.tipoContaPagarId)}
                            onChange={(selected) =>
                                setFilters(prev => ({ ...prev, tipoContaPagarId: selected?.value.toString() || '' }))
                            }
                            isClearable
                            placeholder="Selecione o tipo de conta"
                        />
                    </Col>
                </Row>

                <Row className="align-items-center mb-4">
                    <Col xs="12" className="d-flex justify-content-start justify-content-md-end">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.Financeiro, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#3D9970" }}
                                className="btn-filter ml-2"
                                onClick={() => setCreateMultiplasModalOpen(true)}
                            >
                                Adicionar múltiplas contas
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar conta
                            </Button>
                            <Button
                                style={{ background: "#585858", color: "#FFF" }}
                                onClick={() => setExportModalOpen(true)}
                            >
                                Exportar Relatório PDF
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Financeiro, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Código Transação</th>
                                        <th>Documento</th>
                                        <th>Observação</th>
                                        <th>Data Emissão</th>
                                        <th>Vencimento</th>
                                        <th>Valor</th>
                                        <th>Taxa</th>
                                        <th>Status</th>
                                        <th>Forma Pgmt.</th>
                                        <th>Tipo Conta</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listContaPagar.map((contaPagar: ContaPagarType, index: number) => {

                                        const rowColor = getColorByDay(contaPagar.vencimento);

                                        return (
                                            <tr key={index} style={{ backgroundColor: rowColor }}>
                                                <td>{contaPagar.codigoTransacao}</td>
                                                <td>{contaPagar.documento}</td>
                                                <td>{contaPagar.historico}</td>
                                                <td>{new Date(contaPagar.dataEmissao).toLocaleDateString('pt-BR')}</td>
                                                <td>{contaPagar.vencimento && contaPagar.vencimento.split('-').reverse().join('/')}</td>
                                                <td>{contaPagar.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{contaPagar.taxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>
                                                    {contaPagar.status === 0 && <span className="badge badge-warning">Pendente</span>}
                                                    {contaPagar.status === 1 && <span className="badge badge-success">Concluído</span>}
                                                </td>
                                                <td>{contaPagar.formaPagamentoName}</td>
                                                <td>{contaPagar.tipoContaPagarName}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Financeiro, 3) && (
                                                        <Button onClick={() => { handleEditContaPagar(contaPagar) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Financeiro, 4) && (
                                                        <Button onClick={() => handleDeleteContaPagar(contaPagar.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                    <Button
                                                        onClick={() => {
                                                            reverterContaParaPendente(contaPagar.id)
                                                                .then((success) => {
                                                                    if (success) {
                                                                        getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1);
                                                                    }
                                                                })
                                                                .catch((error) => console.error("Erro ao reverter status:", error));
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-rotate-left"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="text-right mt-3">
                                <strong>
                                    Total das contas filtradas:&nbsp;
                                    {typeof contaPagarTotalValor === "number"
                                        ? contaPagarTotalValor.toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        })
                                        : "R$ 0,00"}
                                </strong>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllContaPagarPaged(
                                                1,
                                                newSize,
                                                objUserTk.EmpresaId,
                                                filters.dataInicial,
                                                filters.dataFinal,
                                                1,
                                                filters.codigoTransacao || undefined,
                                                filters.documento || undefined,
                                                filters.historico || undefined,
                                                filters.contaFinanceiraId ? Number(filters.contaFinanceiraId) : undefined,
                                                filters.categoriaFinanceiraId ? Number(filters.categoriaFinanceiraId) : undefined,
                                                filters.formaPagamentoId ? Number(filters.formaPagamentoId) : undefined,
                                                filters.tipoContaPagarId ? Number(filters.tipoContaPagarId) : undefined
                                            );
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {contaPagarPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaPagarPageCount}
                                        />
                                    </div>
                                )}

                                {listContaPagar.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as contas do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateContaPagarModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1)}
            />

            <EditContaPagarModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                conta={editingContaPagar}
                onUpdated={() => getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 1)}
            />

            <CreateMultiplasContasPagarModal
                isOpen={createMultiplasModalOpen}
                toggle={() => setCreateMultiplasModalOpen(false)}
                onCreated={() => {
                    setCreateMultiplasModalOpen(false);
                    getAllContaPagarPaged(1, pageSize, objUserTk.EmpresaId, "", "", 0);
                }}
            />

            <ExportRelatorioModal
                isOpen={exportModalOpen}
                toggle={() => setExportModalOpen(false)}
                filters={{ ...filters, status: 1 }}
                onExport={(selectedFields) => exportRelatorioContaPagar({ ...filters, status: 1 }, selectedFields)}
            />
        </>
    );
};

export default ContaPaga;
